import { usePresenter, useUseCase } from '@magicdoor/magic-use-case-solid';
import { useVersionManager, ManagedStatus } from '@magicdoorinc/avm';
import { useLocation } from '@solidjs/router';
import { createEffect, JSX, on, Show } from 'solid-js';
import { MaintenancePage } from '~/components/common/MaintenanceMode/MaintenancePage';
import { Footer } from '~/components/layouts/Footer';
import { Header } from '~/components/layouts/Header';
import { useStyling } from '~/global-contexts/CompanyStyling';
import { presentVersion } from '~/presenters/VersionPresenter';
import { GetVersionsUseCase } from '~/use-cases/getVersionsUseCase';
import { SiteRoute } from '~/use-cases/types/SiteRoute';
import BackTop from '../common/back-top/BackTop';

export interface LayoutProps {
  children: JSX.Element;
}

export default function HomeLayout(props: LayoutProps) {
  const { companyStyling } = useStyling();
  const location = useLocation();
  const { execute: getVersions } = useUseCase(GetVersionsUseCase);
  const { model: versions } = usePresenter(presentVersion);

  useVersionManager({
    versionFetcher: async () => {
      await getVersions();
    },
  });

  createEffect(
    on(
      () => versions()?.status,
      (current, previous) => {
        if (previous === ManagedStatus.Maintenance && current === ManagedStatus.Ok) {
          window.location.reload();
        }
      }
    )
  );

  const isRentalApplication = () => location.pathname.includes(SiteRoute.RentalApplications);
  const isInsurance = () => location.pathname.includes('/insurance');
  const isSigner = () => location.pathname.includes(SiteRoute.LeaseSigning);
  const isCompanyNotFound = () => location.pathname.includes(SiteRoute.CompanyNotFound);
  const shouldShowHeaderAndFooter = () => !isRentalApplication() && !isSigner() && !isCompanyNotFound() && !isInsurance();

  return (
    <Show when={versions()?.status !== ManagedStatus.Maintenance} fallback={<MaintenancePage />}>
      <>
        {shouldShowHeaderAndFooter() ? (
          <div class="flex h-screen w-full flex-col items-center">
            <Header companyStyling={companyStyling?.()} />
            <div class="mt-0 w-full pt-10 md:pt-32">{props.children}</div>
            <Footer companyStyling={companyStyling?.()} />
          </div>
        ) : (
          <>{props.children}</>
        )}
        <Show when={shouldShowHeaderAndFooter()}>
          <BackTop />
        </Show>
      </>
    </Show>
  );
}
